import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="resumin--skill-sheet-profile-name-copy"
export default class extends Controller {
  static targets = ["firstName", "lastName"];
  connect() {}

  copyLastName(e) {
    const lastName = e.target.value;
    this.lastNameTarget.value = lastName;
  }

  copyFirstName(e) {
    const firstName = e.target.value;
    this.firstNameTarget.value = firstName;
  }
}
